import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getCountries } from 'actions/countries';

import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

class Flag extends React.Component {
    constructor(props) {
        super(props);

        this.changeSelect = this.changeSelect.bind(this);
    }

    changeSelect(e, i, value) {
        this.props.changeAutoComplete('flag', this.props.countries.find((country) => {
            return country._id === value;
        }))
    }

    componentDidMount() {
        this.props.getCountries();
    }

    render() {
        const { getError, countries, confirmed, flagObject, modifiedFields, underStyle } = this.props;

        return (
            <SelectField
                value={flagObject._id}
                onChange={this.changeSelect}
                errorText={getError && getError('flag')}
                maxHeight={200}
                name='flag'
                disabled={confirmed}
                floatingLabelText='Flag'
                fullWidth

                underlineStyle={modifiedFields && modifiedFields.includes('flag') ? underStyle : null}
            >
                {
                    countries.map((country, index) => {
                        return (
                            <MenuItem
                                key={index}
                                value={country._id}
                                primaryText={country.name}
                            />
                        );
                    })
                }
            </SelectField>
        );
    }
}

export default connect(
    ({ countries: { items }}) => {
        return {
            countries: items,
        };
    },
    dispatch => bindActionCreators({
        getCountries,
    }, dispatch),
)(Flag);


// WEBPACK FOOTER //
// ./app/components/Vessels/Single/Rows/Flag.jsx